module.exports = __webpack_public_path__ + "img/battracker-250.686886c6.jpg";